import React from 'react';
import { isSome, formatCurrency } from 'core/utils';
import { BaasicInput } from 'core/components';
import moment from 'moment';
import 'moment-timezone';
import _ from 'lodash';
import { isObservableArray } from 'mobx';
import { defaultTemplate } from 'core/hoc';

function RenderRow({ item, column, form, fieldName, hasRowClick, ...props }) {
	const rowProps = {};
	if (column.onClick) {
		rowProps.onClick = () => column.onClick(item, column);
	}

	// extension for inline edit functionality
	if (isSome(form) && item.forEdit === true) {
		return (
			<td key={column.key} className="table__body--data input--no-label" width={column.width}>
				<BaasicInput field={form.$(fieldName)} />
			</td>
		);
	}

	var columnData = '';
	if (item[column.key]) {
		columnData = item[column.key];
	} else {
		// Nested
		let keys = _.split(column.key, '.');
		let baseItem = item;
		_.forEach(keys, key => {
			if (baseItem[key] !== null) {
				baseItem = baseItem[key];
			}
		});
		if (item !== baseItem) {
			columnData = baseItem;
		}
	}
	while (columnData !== null) {
		if (column.type === 'date') {
			if (columnData) {
				let format = column.format;
				if (!format) {
					let locale = window.navigator.userLanguage || window.navigator.language;
					moment.locale(locale);
					// Get locale data
					let localeData = moment.localeData();
					format = localeData.longDateFormat('L');
				}
				columnData = moment(columnData)
					.tz(Intl.DateTimeFormat().resolvedOptions().timeZone)
					.format(format);
			}
			break;
		}
		if (column.type === 'currency') {
			columnData = formatCurrency(columnData);
			break;
		}
		if (column.type === 'lookup') {
			if ((_.isArray(columnData) || isObservableArray(columnData)) && columnData.length > 0) {
				columnData = columnData.map(data => data.label).join(', ');
			} else {
				if (columnData) {
					columnData = typeof columnData === 'object' ? columnData.label : columnData.toString();
				} else {
					columnData = '';
				}
			}
			break;
		}
		if (columnData && typeof columnData.toString === 'function') {
			columnData = columnData.toString();
			if (columnData === '[object Object]') {
				columnData = '';
			}
			break;
		}
		break;
	}
	if (column.row) {
		if (column.processContent) item[column.key] = columnData;
		return (
			<React.Fragment key={column.key}>
				<column.row {...rowProps} item={item} column={column} {...props} width={column.width} />
			</React.Fragment>
		);
	}
	return (
		<td
			key={column.key}
			className={column.onClick || hasRowClick ? 'table__body--data hoverable' : 'table__body--data'}
			width={column.width}
		>
			<div {...rowProps}>{columnData}</div>
		</td>
	);
}

function BaasicTableRowTemplate({ item, form, columns, actions, actionsComponent, onRowClick, ...props }) {
	const rowProps = {};

	// extension for inline edit functionality
	if (isSome(form)) {
		var fields = form.fields._keys;
	}

	if (onRowClick) {
		rowProps.onClick = () => onRowClick(item);
	}

	const wrap = {
		component: actionsComponent,
	};
	return (
		<tr {...rowProps}>
			{isSome(form)
				? columns.map((column, idx) => {
						return (
							<RenderRow
								key={column.key}
								item={item}
								column={column}
								form={form}
								fieldName={fields[idx]}
								hasRowClick={onRowClick ? true : false}
								{...props}
							/>
						);
				  })
				: columns.map(column => {
						return (
							<RenderRow
								key={column.key}
								item={item}
								column={column}
								hasRowClick={onRowClick ? true : false}
								{...props}
							/>
						);
				  })}
			{isSome(actions) ? <wrap.component actions={actions} item={item} {...props} /> : null}
		</tr>
	);
}

export default defaultTemplate(BaasicTableRowTemplate);
